import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { useRequestForgotPassword } from '~entities/users/api/request-forgot-password';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '~shared/shadcn/ui/alert-dialog';
import { Button } from '~shared/shadcn/ui/button';

interface ForgotPasswordConfirmationProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  email: string;
  locationId: string;
}

export const ForgotPasswordConfirmation = ({
  open,
  onOpenChange,
  email,
  locationId,
}: ForgotPasswordConfirmationProps) => {
  const { mutateAsync: requestForgotPassword, isPending } =
    useRequestForgotPassword();

  const handleForgotPassword = async () => {
    try {
      await requestForgotPassword({
        email,
        locationId,
      });
      toast.success('One-time password sent to your email');
      onOpenChange(false);
    } catch {
      // Error toast is already shown by the mutation's onError (ENR-4044).
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Forgot Password</AlertDialogTitle>
          <AlertDialogDescription>
            You will receive an email containing a one-time password to set a
            new password.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <Button onClick={handleForgotPassword} disabled={isPending}>
            {isPending && <Loader2 className='animate-spin' />} Send
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
